import fetcher from 'api/fetcher';

import { urlParser } from '@hh.ru/browser-api-utils';

import {
    CampaignStatistics,
    setCampaignsStatistics,
    setIsCampaignsStatisticsLoading,
} from 'store/models/campaignsDashboard';
import { AppThunkAction } from 'store/utils';

type FetchCampaignsStatistics = (options: {
    campaignIds: string[];
    abortSignal: AbortSignal;
}) => AppThunkAction<Promise<void> | null>;

export const fetchCampaignsStatistics: FetchCampaignsStatistics = ({ campaignIds, abortSignal }) => {
    return (dispatch) => {
        const queryStr = urlParser.stringify({
            campaignIds,
        });

        return fetcher
            .get<unknown, Record<string, CampaignStatistics>>(`/api/v2/campaigns/statistics?${queryStr}`, {
                signal: abortSignal,
                timeout: 10000,
            })
            .then((statistics) => {
                dispatch([setIsCampaignsStatisticsLoading(false), setCampaignsStatistics(statistics)]);
            })
            .catch(() => {
                dispatch([setIsCampaignsStatisticsLoading(false), setCampaignsStatistics(null)]);
            });
    };
};
